export const FETCH_ARTICLES = 'FETCH_ARTICLES';